import axios from "axios";

class UsersService {

    async save(id, username, fname, lname, phone, email, userRoles, active, domain) {
        if (id === null) {
            return this.insert(username, fname, lname, phone, email, userRoles, active, domain);
        } else {
            return this.update(id, username, fname, lname, phone, email, userRoles, active, domain);
        }
    }

    async insert(username, fname, lname, phone, email, userRoles, active, domain) {
        return await axios.post(`/api/v1/users`, {
            username: username,
            fname: fname,
            lname: lname,
            phone: phone,
            email: email,
            user_roles: userRoles,
            active: active,
            domain: domain
        }).then(response => response.data);
    }

    async update(id, username, fname, lname, phone, email, userRoles, active, domain) {
        return await axios.put(`/api/v1/users`, {
            id: id,
            username: username,
            fname: fname,
            lname: lname,
            phone: phone,
            email: email,
            user_roles: userRoles,
            active: active,
            domain: domain
        }).then(response => response.data);
    }

    async list() {
        return await axios.get('/api/v1/users')
            .then(response => response.data);
    }

    async listActiveUsers() {
        return await axios.get('/api/v1/users-active')
            .then(response => response.data);
    }

    async thinList() {
        return await axios.get('/api/v1/users/thin')
            .then(response => response.data);
    }

    async jobsList() {
        return await axios.get('/api/v1/users/jobs')
            .then(response => response.data);
    }
    
    async delete(id) {
        return await axios.delete(`/api/v1/users?id=${id}`)
            .then(response => response.data);
    }

    async roles() {
        return await axios.get('/api/v1/roles')
            .then(response => response.data);
    }
    async changePassword(id, oldPassword, newPassword) {
        return await axios.post(`/api/v1/users/password-change`, {
            id:id,
            oldPassword: oldPassword,
            newPassword: newPassword,
        }).then(response => response.data);
        
    }
    async resetPassword(id) {
        return await axios.post(`/api/v1/users/password-reset`, {
            id:id,
        }).then(response => response.data);
        
    }

}

const usersService = new UsersService();
export default usersService;